// @styles
import Context from "context/appContext";
import { useContext } from "react";
import "./styles.scss";

export default function TitleDescription({ info }) {
  const {
    dataForm: { hiddenFields },
  } = useContext(Context);

  return (
    <div
      className="text-ppl"
      id={info.key}
      style={{
        position: "relative",
        display: hiddenFields[info.key] ? "none" : "block",
      }}
    >
      <h3 className="text-ppl__title">{info && info.label}</h3>
      <p className="text-ppl__description">{info && info.description}</p>
    </div>
  );
}
